import { StyleSheet, Text } from '@react-pdf/renderer'
import React from 'react'
import { ErrorBoundary } from '../../error-boundary'

const styles = StyleSheet.create({
	h3: {
		fontSize: 11,
		fontFamily: 'Inter',
		fontWeight: 'bold',
		marginBottom: 6,
		textAlign: 'justify',
	},
})

const H3 = ({ children }: { children: React.ReactNode }) => (
	<ErrorBoundary message={'Error in H3'}>
		<Text style={styles.h3}>{children}</Text>
	</ErrorBoundary>
)

export default H3
